// frontend/src/components/Shell.js
import { NavLink, useLocation } from "react-router-dom";
import {
  BriefcaseBusiness, FolderOpen, LockKeyhole, LogOut,
  MessageSquareText, Moon, Settings, Sun, UserRound,
} from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { useDarkModeContext } from "../context/DarkModeContext";

export default function Shell({ children }) {
  const auth = useAuth();
  const darkMode = useDarkModeContext();
  const location = useLocation();
  const isInterview = location.pathname.startsWith("/interview/");
  return (
    <div className={`app-shell ${isInterview ? "interview-shell" : ""}`} data-testid="app-shell">
      <aside className="sidebar" data-testid="sidebar-navigation">
        <div className="sidebar-brand" data-testid="sidebar-brand">
          <span>P</span>
          <strong>Prime Portfolio</strong>
          <button className="mode-toggle-btn mode-toggle-sidebar" onClick={darkMode.toggle} aria-label="Toggle colour mode" data-testid="mode-toggle-button">
            {darkMode.mode === 'light' ? <Moon size={16} /> : <Sun size={16} />}
          </button>
        </div>
        <nav data-testid="main-navigation">
          <NavLink data-testid="nav-dashboard-link" to="/app" end><BriefcaseBusiness size={18} /> Dashboard</NavLink>
          <NavLink data-testid="nav-interviews-link" to="/interviews"><MessageSquareText size={18} /> Interviews</NavLink>
          <NavLink data-testid="nav-outputs-link" to="/outputs"><FolderOpen size={18} /> Outputs</NavLink>
          <NavLink data-testid="nav-account-link" to="/account"><LockKeyhole size={18} /> Account</NavLink>
          {auth.user?.role === "admin" && <NavLink data-testid="nav-admin-link" to="/admin"><Settings size={18} /> Admin</NavLink>}
        </nav>
        <div className="profile-chip" data-testid="profile-chip">
          <UserRound size={18} />
          <div><strong data-testid="profile-name">{auth.user?.name}</strong><span data-testid="profile-email">{auth.user?.email}</span></div>
        </div>
        <button className="ghost-action" onClick={auth.logout} data-testid="logout-button"><LogOut size={17} /> Log out</button>
      </aside>
      <main className="workspace" data-testid="workspace-main">{children}</main>
    </div>
  );
}
